// Get stage from template or default to dev
const stage = 'dev';

export const envConfig = {
    Auth: {
        identityPoolId: 'us-west-2:b73f8145-e7e8-44f5-a6bb-65eb627f14d1',
        region: 'us-west-2',
        userPoolId: 'us-west-2_q5xxyS9lo',
        userPoolWebClientId: 'ft5eetscbmpsbglv8juqmhmku',
        mandatorySignIn: true,
        oauth: {
            domain: 'finspace-dev-reddypn' + '.auth.us-west-2.amazoncognito.com',
            redirectSignIn: 'https://' + window.location.host + '/',
            redirectSignOut: 'https://' + window.location.host+ '/',
            scope: ['openid'],
            responseType: 'code',
        },
    },
    API: {
        endpoints: [
            {
                name: 'FinSpaceService',
                endpoint: `https://api.test.service.finspace.finergy.amazon.dev`,
                region: 'us-west-2',
            },
        ],
    },
};
